import {
  useNavigate,
} from 'react-router';
import Modal from 'react-modal';
import { Icon } from 'web-components';
import { Flex, Text, SVG } from 'web-styled';
import {
  trackAnalyticsEvent,
} from 'web-utils';

import * as S from './styled'
import {
  Features,
  MessagesIcon,
  CalendarIcon,
  ChartIcon,
  VideocamIcon,
  DocumentIcon,
} from './FeatureIcons'

type Props = {
  isOpen: boolean
  showButton?: boolean
  onRequestClose: () => void
};

type Feature = {
  text: string;
  bold?: boolean;
  icon: any
};

const FeatureItem = ({ text, FeatureIcon }: { text: string; FeatureIcon: any }) => (
  <Flex align="center" spacing={10}>
    <Flex width="28px" height="28px">
      <FeatureIcon />
    </Flex>
    <Text size="16px" color="#121827" dangerouslySetInnerHTML={{ __html: text }} />
  </Flex>
)

const premiumFeatures: Feature[] = [
  { text: 'All free features plus exclusive premium features', icon: Features },
  { text: '<b>In-app messaging</b> for all client communication', icon: MessagesIcon, },
  { text: '<b>Schedule workouts</b> and programs', icon: CalendarIcon },
  { text: '<b>Track client results</b>', icon: ChartIcon },
  { text: 'Manage your <b>video library</b>', icon: VideocamIcon },
  { text: '<b>Share documents</b> with your clients', icon: DocumentIcon },
]

const customStyles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    overflow: 'hidden auto',
    paddingBottom: '50px',
    zIndex: 9999,
  },
  content: {
    padding: 0,
    borderRadius: 16,
    position: 'relative',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '450px',
    border: 'none',
    outline: 'none',
    overflow: 'hidden',
  },
}

const UpgradePlanModal = ({ isOpen, showButton, onRequestClose }: Props) => {
  const navigate = useNavigate();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        overlay: customStyles.overlay,
        content: customStyles.content,
      }}
      appElement={document.body}
    >
      <S.Header>
        <S.Title>
          Unlock <br />
          IDEAfit Program Builder +
        </S.Title>
        <S.Close onClick={onRequestClose}>
          <SVG.X size={13} />
        </S.Close>
      </S.Header>
      <S.Body>
        <Flex column align="center" width="100%">
          <Flex column spacing={24}>
            {premiumFeatures.map((feature, idx) => (
              <FeatureItem key={idx} text={feature.text} FeatureIcon={feature.icon} />
            ))}
          </Flex>

          {showButton && (
            <S.Upgrade
              onClick={() => {
                trackAnalyticsEvent('clicked_upgrade_plan')
                navigate('/payments/details')
                onRequestClose()
              }}
            >
              Upgrade Now
            </S.Upgrade>
          )}
        </Flex>
      </S.Body>
    </Modal>
  )
};

export default UpgradePlanModal;
